export default __webpack_public_path__ + "static/Flat-Category-3fa8016bb43a71057d18f535c6e9d048.webp";